module.exports = __webpack_public_path__ + "media/images/arrow1-fed4c484204399677b7cf887ce5909c5.png";